
import React from 'react';

const Stats: React.FC = () => {
  const stats = [
    { label: 'Avg. Savings', value: '₹45,000', prefix: 'Up to' },
    { label: 'Quotes Beaten', value: '25,000+', prefix: 'India Wide' },
    { label: 'Guaranteed Discount', value: '1%', prefix: 'Extra' },
    { label: 'Processing Time', value: '< 2min', prefix: 'Instant' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 px-8 py-12 max-w-6xl mx-auto">
      {stats.map((stat, i) => (
        <div key={i} className="glass p-6 rounded-2xl border border-white/5 hover:border-white/10 transition-colors group">
          <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-1">{stat.prefix}</p>
          <p className="text-2xl md:text-3xl font-black font-display group-hover:text-blue-400 transition-colors">{stat.value}</p>
          <p className="text-xs text-gray-400 mt-2 font-medium">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default Stats;
